export default function triToggleDirective($timeout) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: true,
		templateUrl: "./components/tri-toggle/tri-toggle-template.html",
		scope: {
			model: "=",
			disabled: "=?",
            hidden: "=?",
			onChange: "&"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function ($scope, $element) {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				vm.refreshState();
				$scope.$watch(() => (vm.model), vm.refreshState);
			};

			vm.$postLink = () => {
				$timeout(() => {
					$element.find(".val-false-click-area, .val-true-click-area")
						.off("click")
						.on("click", vm.onClick);
				});
			};

			vm.refreshState = () => {
				vm.state = vm.model ? "on" : "off";
			};

			vm.onClick = () => {
				$timeout(() => {
					if (!vm.disabled && !vm.hidden) {
						vm.model = !vm.model;
						vm.refreshState();
					}
				});
				return false;
			};

			vm.onToggle = () => {
				vm.model = (vm.state === "on");
				$timeout(() => {
					if (vm.onChange) {
						vm.onChange();
					}
				});
			};
		}
	};
}
